import { useContext, useState } from 'react';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';

import { CREATE_ERROR } from '../../graphql_queries/errors';
import { UserContext } from '../contexts/UserContext';

const ErrorLogCreation = ({ error, userInfo, onErrorCreated }) => {
  const [errorCreating, setErrorCreating] = useState(false);
  const [creatingError, setCreatingError] = useState(false);
  const { user } = useContext(UserContext);
  const userInfoDetails = userInfo || user;

  const onError = () => {
    setErrorCreating(true);
  };

  const [createError, { data: dataCreate, error: errorCreate }] = useMutation(CREATE_ERROR, { onError: () => onError() });

  if (!creatingError) {
    const clientInfo = {
      browser: navigator.userAgent,
      clientVersion: process.env.REACT_APP_VERSION,
    };

    createError({ variables: {
      errorMessage: error.message,
      errorStack: error.stack,
      errorInfo: error.info && JSON.stringify(error.info),
      userInfo: userInfoDetails && JSON.stringify(userInfoDetails),
      url: window.location?.href,
      clientInfo: JSON.stringify(clientInfo),
    } });
    setCreatingError(true);
  } else if (!dataCreate && !errorCreate && !errorCreating) {
    if (onErrorCreated) {
      onErrorCreated();
    }
  }

  return null;
};

ErrorLogCreation.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string.isRequired,
    stack: PropTypes.string.isRequired,
    info: PropTypes.shape({}),
  }).isRequired,
  userInfo: PropTypes.shape({}),
  onErrorCreated: PropTypes.func,
};

export default ErrorLogCreation;
